import './Footer.scss';

const Footer = () => {
  return <div className="mainContainerFooter">MrbyWater</div>;
};

export { Footer };
